// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
import i18n from '@/lang'
import Message from '@/components/message'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import BasePage from '@/components/page/index.vue'

/* 设置语言。并根据语言引入样式文件 */
/* i18n.locale = process.env.LANG
import(`@/styles/${process.env.LANG}/index.scss`)
document.documentElement.lang = process.env.LANG */

i18n.locale = 'en'
import(`@/styles/en/index.scss`)
document.documentElement.lang = 'en'

if (process.env.LANG === 'en'){
  Vue.use(ElementUI, { locale })
}else if(process.env.LANG === 'zh'){
  Vue.use(ElementUI)
}

// Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(Message)
Vue.http.options.emulateJSON = true
Vue.component('base-page', BasePage)

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js